import { Reveal } from '../components/Reveal';

const milestones = [
  ['1953', 'Nasce em Francisco Beltrão, no Sudoeste do Paraná.'],
  ['1982', 'Inicia a vida pública como vereador em Santo Antônio do Sudoeste e preside a Câmara Municipal.'],
  ['1985–1988', 'Exerce o mandato de prefeito de Santo Antônio do Sudoeste.'],
  ['1990', 'É eleito deputado estadual pela primeira vez.'],
  ['2015–2025', 'Preside a Assembleia Legislativa do Paraná em mandatos sucessivos.'],
  ['2022', 'Filia-se ao Partido Social Democrático (PSD).'],
  ['Atualidade', 'Exerce mandato de deputado estadual e preside a Comissão de Constituição e Justiça da Assembleia.'],
] as const;

export function ProfilePage() {
  return <>
    <section className="profile-hero">
      <div className="shell profile-hero__grid">
        <Reveal className="profile-hero__copy">
          <p className="profile-hero__label">Trajetória pública</p>
          <h1>Ademar<br /><span>Traiano.</span></h1>
          <p>Do Sudoeste do Paraná à Assembleia Legislativa: uma trajetória iniciada na política municipal e construída ao longo de mais de quatro décadas de vida pública.</p>
          <dl className="profile-hero__facts">
            <div><dt>Naturalidade</dt><dd>Francisco Beltrão</dd></div>
            <div><dt>Mandato atual</dt><dd>Deputado estadual</dd></div>
            <div><dt>Partido</dt><dd>PSD</dd></div>
          </dl>
        </Reveal>
        <Reveal delay={0.08} className="profile-hero__portrait">
          <img src={`${import.meta.env.BASE_URL}assets/images/TraianoMainPicture.png`} alt="Retrato de Ademar Traiano" />
        </Reveal>
      </div>
    </section>

    <section className="profile-story">
      <div className="shell profile-story__grid">
        <Reveal className="profile-story__intro">
          <p>Uma história ligada aos municípios</p>
          <h2>Da política local ao Legislativo paranaense.</h2>
          <div className="profile-story__prose">
            <p>Ademar Luiz Traiano nasceu em 3 de janeiro de 1953, em Francisco Beltrão. Sua trajetória política começou em Santo Antônio do Sudoeste, onde foi vereador, presidente da Câmara Municipal e prefeito.</p>
            <p>Eleito deputado estadual pela primeira vez em 1990, passou a exercer sucessivos mandatos na Assembleia Legislativa do Paraná. Entre 2015 e 2025, presidiu a Casa; atualmente permanece deputado estadual e preside a Comissão de Constituição e Justiça.</p>
          </div>
        </Reveal>
        <Reveal delay={0.08} className="profile-story__image">
          <img src={`${import.meta.env.BASE_URL}assets/images/ademar-traiano-alep-2016.jpg`} alt="Ademar Traiano durante atividade na Assembleia Legislativa do Paraná, em 2016" />
          <p>Foto: Pedro de Oliveira/Alep · Wikimedia Commons · domínio público</p>
        </Reveal>
      </div>
    </section>

    <section className="profile-timeline">
      <div className="shell">
        <Reveal className="profile-timeline__heading">
          <h2>Marcos de uma vida pública.</h2>
          <p>Uma cronologia essencial, organizada a partir de registros públicos.</p>
        </Reveal>
        <ol>
          {milestones.map(([year, text], index) => <li key={year}><Reveal delay={Math.min(index * 0.035, 0.18)}>
            <time>{year}</time><p>{text}</p>
          </Reveal></li>)}
        </ol>
      </div>
    </section>

  </>;
}
